<template>
    <div>
        <div class="text-small text-gray pb-8">
            <a href="/admin">Admin</a> > Groups
        </div>
        <d-table :data="groups" detailed :loading="loadingGroups" paginated backend-pagination :total="total" backend-sorting :default-sort="[pagination.sortField, pagination.sortOrder]" striped detail-key="id" default-sort-direction="desc" :per-page="pagination.pageSize" @page-change="page => pagination.page = page" @sort="onSort">
            <template #action-buttons>
                <h2 class="text-primary-500 mb-0">
                    Groups
                </h2>
            </template>
            <template #action-buttons-right>
                <d-checkbox v-model="showArchivedGroups" :native-value="false" class="mr-5" @input="getGroupsPaged">
                    Show Archived Groups
                </d-checkbox>
                <d-checkbox v-model="filterMenteeGroups" :native-value="true" class="mr-5" @input="getGroupsPaged">
                    Exclude Mentee Groups
                </d-checkbox>
                <d-checkbox v-model="filterAutogeneratedGroups" :native-value="true" class="mr-5" @input="getGroupsPaged">
                    Exclude Auto Generated Groups
                </d-checkbox>
                <filter-dropdown v-model="filter" />
                <d-btn class="" @click="launchGroupsModal()">
                    + Add Group
                </d-btn>
            </template>
            <template slot-scope="props">
                <d-table-column field="name" :row="props.row" label="Group Name" sortable>
                    <b> {{ props.row.name }} </b>
                </d-table-column>
                <d-table-column field="description" :row="props.row" label="Description" sortable>
                    {{ props.row.description }}
                </d-table-column>
                <d-table-column field="autoGenerated" :row="props.row" label="Auto Generated" sortable centered class="text-center">
                    <d-icon v-if="props.row.autoGenerated" icon="check" />
                    <span v-else />
                </d-table-column>
                <d-table-column field="memberCount" :row="props.row" label="Member Count">
                    {{ props.row.memberCount }}
                </d-table-column>

                <d-table-column class="text-right">
                    <d-icon icon="envelope" class="cursor-pointer ml-4" @click.native="launchNotificationsModal(props.row)" />
                </d-table-column>
                <d-table-column v-if="!props.row.autoGenerated" class="text-right" label="">
                    <div class="flex">
                        <d-icon icon="edit" class="cursor-pointer text-green-500 ml-4" @click.native="launchEditGroupsModal(props.row)" />
                        <d-icon icon="trash" class="cursor-pointer text-primary-500 ml-4" @click.native="deleteGroup(props.row)" />
                    </div>
                </d-table-column>
                <d-table-column v-else />
            </template>

            <template slot="detail" slot-scope="props">
                <group-members-grid :group="props.row" />
            </template>
        </d-table>
    </div>
</template>

<script>
    import axios from 'axios';
    import ViewNotificationModal from '@resources/scripts/patterns/ViewNotificationModal.vue';
    import localforage from 'localforage';
    import GroupsModal from './components/GroupsModal.vue';

    export default {
        parent: true,

        data: () => ({
            groups: [],
            filterMenteeGroups: false,
            loadingGroups: false,
            showArchivedGroups: false,
            filterAutogeneratedGroups: false,
            total: 0,
            filter: '',
            pagination: {
                page: 1,
                pageSize: 50,
                sortField: 'name',
                sortOrder: 'asc',
            },
        }),

        watch: {
            pagination: {
                handler() {
                    this.getGroupsPaged();
                },
                deep: true,
            },
            filter() {
                this.getGroupsPaged();
            },
        },

        mounted() {
            localforage.getItem('filterMenteeGroups')
                .then((value) => {
                    if (value !== null) {
                        this.filterMenteeGroups = value;
                    }
                });

            localforage.getItem('filterAutogeneratedGroups')
                .then((value) => {
                    if (value !== null) {
                        this.filterAutogeneratedGroups = value;
                    }
                })
                .finally(() => {
                    this.getGroupsPaged();
                });
        },

        methods: {
            async getGroupsPaged() {
                localforage.setItem('filterMenteeGroups', this.filterMenteeGroups);
                localforage.setItem('filterAutogeneratedGroups', this.filterAutogeneratedGroups);

                const {
                    page, sortField, sortOrder, pageSize,
                } = this.pagination;
                const params = [`filter=${this.filter}`, `sortDir=${sortField} ${sortOrder}`, `currentPage=${page}`, `pageSize=${pageSize}`, `filterMenteeGroups=${this.filterMenteeGroups}`, `showArchivedGroups=${this.showArchivedGroups}`, `filterAutogeneratedGroups=${this.filterAutogeneratedGroups}`].join('&');
                this.loadingGroups = true;
                const { data } = await axios.get(`/api/admin/groups/paged?${params}`);
                this.groups = data.resultItems;
                this.total = data.totalRecords;
                console.log(this.groups);
                this.loadingGroups = false;
            },

            launchGroupsModal() {
                this.$modal.open({
                    parent: this,
                    component: GroupsModal,
                    hasModalCard: true,
                    events: {
                        getGroupsPaged: () => this.getGroupsPaged(),
                    },
                });
            },

            launchNotificationsModal(group) {
                this.$modal.open({
                    parent: this,
                    component: ViewNotificationModal,
                    hasModalCard: true,
                    props: {
                        entityId: group.id,
                        type: 'group',
                        name: group.name,
                    },
                });
            },

            launchEditGroupsModal(group) {
                this.$modal.open({
                    parent: this,
                    component: GroupsModal,
                    hasModalCard: true,
                    props: {
                        group,
                    },
                    events: {
                        getGroupsPaged: () => this.getGroupsPaged(),
                    },
                });
            },

            async deleteGroup(group) {
                this.$dialog.confirm({
                    title: 'Deleting Group',
                    message: `Are you sure you want to <b>delete</b> ${group.name}? This action cannot be undone.`,
                    confirmText: 'Delete Group',
                    confirmColor: 'red-500',
                    onConfirm: async () => {
                        await axios.delete(`/api/admin/groups/${group.id}`);
                        this.getGroupsPaged();
                        this.$toast.success('Group deleted!');
                    },
                });
            },

            gotoNotificationsPage(group) {
                window.location = `/system/notifications?type=group&entityId=${group.id}`;
            },

            onSort(field, order) {
                this.pagination.sortField = field;
                this.pagination.sortOrder = order;
            },

        },

    };
</script>
